import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { BarChart } from '../../../../../../components/bar-chart/bar-chart';
import { messages } from '../../messages';
import styles from './transfer-order-progress-bar.styles.module.less';

type TransferOrderProgressBarProps = {
  receivedItems: number;
  rejectedItems?: number;
  totalItems: number;
  renderWithoutItemsCopy?: boolean;
};

export const TransferOrderProgressBar = ({
  receivedItems,
  rejectedItems = 0,
  totalItems,
  renderWithoutItemsCopy = false,
}: TransferOrderProgressBarProps) => {
  const reportedItems = receivedItems + rejectedItems;
  const withOverflow = totalItems - reportedItems < 0 ? reportedItems : totalItems;
  const receivedPercentage = withOverflow === 0 ? 0 : Math.min(((receivedItems ?? 0) / withOverflow) * 100, 100);
  const rejectedPercentage = withOverflow === 0 ? 0 : Math.min((rejectedItems / withOverflow) * 100, 100);

  const itemsProgressMessage = renderWithoutItemsCopy ? (
    `${reportedItems}/${totalItems}`
  ) : (
    <FormattedMessage {...messages.items} values={{ reportedItems, totalItems }} />
  );

  const descriptionClasses = `${styles['description-wrapper']} ${
    !reportedItems || totalItems === 0 ? styles['description-not-active'] : ''
  }`;

  const sections = [
    { size: receivedPercentage, color: 'var(--green-700)' },
    { size: rejectedPercentage, color: 'var(--red-600)' },
    {
      size: 100 - receivedPercentage - rejectedPercentage,
      color: 'var(--grey-400)',
    },
  ];

  return (
    <FlexColumn className={styles['progress-bar-wrapper']}>
      <BarChart sections={sections} />
      <FlexRow className={descriptionClasses} gap={Gap.Space16}>
        <Text textType={TextType.Paragraph} value={itemsProgressMessage} />
      </FlexRow>
    </FlexColumn>
  );
};
